import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="code-medium, syntax, brackets, dev"><path d="M17.25 7.75L21.25 12L17.25 16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 16.25L2.75 12L6.75 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCodeMedium;
